import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { UsersListComponent } from './components/users-list/users-list.component'
import { UserComponent } from './components/user/user.component'
import { UserFormComponent } from './components/user-form/user-form.component'
import { EventsListComponent } from './components/events-list/events-list.component'
import { EventComponent } from './components/event/event.component'
import { EventFormComponent } from './components/event-form/event-form.component'
import { LoginComponent } from './components/login/login.component'
import { LayoutComponent } from './components/layout/layout.component'
import { CalendarComponent } from './components/calendar/calendar.component'
import { NotFoundComponent } from './components/not-found/not-found.component'
import { TreesComponent } from './components/trees/trees.component'
import { GroupsFormComponent } from './components/groups-form/groups-form.component'
import { GroupsListComponent } from './components/groups-list/groups-list.component'
import { GroupComponent } from './components/group/group.component'
import { HomeComponent } from './components/home/home.component'

import { MainGuard } from './guards/main.guard'
import { AdminGuard } from './guards/admin.guard'

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },

  // login route without layout
  { path: 'login', component: LoginComponent },

  // all others routes have layout
  {
    path: '',
    canActivate: [MainGuard],
    component: LayoutComponent,
    children: [
      { path: '', component: HomeComponent, data: { adminMenu: 'events' } },
      { path: 'home', component: HomeComponent, data: { adminMenu: 'events' } },
      { path: 'event', component: EventFormComponent },
      { path: 'event/:id', component: EventComponent, data: { adminMenu: 'event' } },
      { path: 'users', component: UsersListComponent, data: { adminMenu: 'users' } },
      { path: 'user', canActivate: [AdminGuard], component: UserFormComponent },
      { path: 'user/:id', component: UserComponent, data: { adminMenu: 'user' } },
      { path: 'calendar', component: CalendarComponent, data: { adminMenu: 'events' } },
      { path: 'trees', component: TreesComponent },
      { path: 'group', component: GroupsFormComponent },
      { path: 'group/:id', component: GroupComponent, data: { adminMenu: 'group' } },
      { path: 'groups', component: GroupsListComponent, data: { adminMenu: 'groups' } },
      { path: '**', component: NotFoundComponent }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RoutingModule {}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/routing.module.ts